import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '../app/hooks/useAuth';
import { UserRole } from '../common/constants';

export const SuperAdminOutlet: React.FC = () => {
  const auth = useAuth();
  const location = useLocation();

  return auth.user != null && auth.user.role === UserRole.SUPER_ADMIN ? (
    <Outlet />
  ) : (
    <Navigate to="/admin" state={{ from: location }} />
  );
};
